// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"218":"d1b03ca0","234":"af57994e","485":"73f97a1f","813":"cf6307c0","830":"7d417392"}[chunkId] + ".chunk.js";
};